export default __webpack_public_path__ + "assets/front/scss/recherche/astuces/styles.ea2dcd4bcf80e4f823a27791a71eb075.css";